import {BaseService} from '../baseService.js';

/* 
 * Handles interaction with the API
 */
export class DataBlockService extends BaseService {
	
	constructor() {	
		super();
	}
	
	async getDataBlocks(companyId, dataType, paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}		
		var data = await this.makeGETRequest('/api/resource/data-blocks/companies/' + companyId + '/data-types/' + dataType + params);		
		return data;
	}	
	
	async getDataBlock(pkValue, dataType) {
		var data = await this.makeGETRequest('/api/resource/data-blocks/' + pkValue + '/data-types/' + dataType);		
		return data;
	}	
	
	async getData(pkValue, dataType, noFormat) {
		var options = '';
		if (noFormat) {
			options = '?noFormat=true';
		}		
		var data = await this.makeGETRequest('/api/resource/data-blocks/' + pkValue + '/data-types/' + dataType + '/data' + options, true);		
		return data;
	}	
	
	downloadData(pkValue, dataType, decompress) {	
		var options = '';
		if (decompress) {
			options = '?decompress=true';
		}	
		this.downloadFile('/api/resource/data-blocks/' + pkValue + '/data-types/' + dataType + '/data-download' + options);		
	};

	exportDataBlocks(companyId, dataType, paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}
		this.downloadFile('/api/resource/data-blocks/companies/' + companyId + '/data-types/' + dataType + '/export' + params);
	}
	
	async saveDataBlock(pkValue, dataType, dataBlockSave) {
		var saved = await this.makePUTRequest('/api/resource/data-blocks/' + pkValue + '/data-types/' + dataType, dataBlockSave);		
		return saved;
	}
		
	async deleteDataBlock(pkValue, dataType) {		
		var result = await this.makeDELETERequest('/api/resource/data-blocks/' + pkValue + '/data-types/' + dataType);		
		return result;
	}

}
